// extracted by mini-css-extract-plugin
export default {"popup-center":"abpop_popup-center__VBS6K","aboutDiv":"abpop_aboutDiv__tam+S","popup-overlay":"abpop_popup-overlay__wZIbO"};